import {
  parseFloatValue,
  parseToDateValue,
  parseIntValue,
} from "@/features/FormCard/utils";
import { z } from "zod";

import {
  DatePickerField,
  InputField,
  SelectField,
} from "@/features/FormCard/Fields";

import { dateSchema } from "@/features/FormCard/utils";

import { vehicle } from "@/data/vehicule.ts";
import { EditForm } from "@/features/Edit/types.ts";
import i18n from "@/i18n";

export const a7FIACompositionsEditForm: EditForm = {
  table_name: "a7_fia_compositions",
  fieldsNotApplyTranslation: ["type_de_position"],
  formSchema: z.object({
    date: z.preprocess((val) => parseToDateValue(val as string), dateSchema),
    a7_fia_instrument_from_id: z.preprocess(
      (val) => parseInt(val as string, 10),
      z.number().int().nullable(),
    ),
    a7_fia_instrument_from_name: z.string().nullable().optional(),
    a7_fia_instrument_to_id: z.preprocess(
      (val) => parseInt(val as string, 10),
      z.number().int().nullable(),
    ),
    a7_fia_issuer_name: z.string().nullable().optional(),
    valorisation_part_du_sous_jacent: z.preprocess(
      (val) => parseFloatValue(val as string),
      z.number().nullable(),
    ),
    detention_du_fonds_dans_le_sous_jacent: z.preprocess(
      (val) => parseFloatValue(val as string),
      z.number().nullable(),
    ),
    a7_fia_time_serie_file_id: z.preprocess(
      (val) => parseIntValue(val as string),
      z.number().int().nullable(),
    ),
    vehicle: z.string().nullable().optional(),
  }),
  formBodyContent: (form, multiFieldOptions) => (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <DatePickerField
          name="date"
          label={i18n.t("a7_fia_compositions.columns.date", {
            ns: "tables",
            defaultValue: "Date",
          })}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="a7_fia_time_serie_file_id"
          label={i18n.t(
            "a7_fia_compositions.columns.a7_fia_time_serie_file_id",
            {
              ns: "tables",
              defaultValue: "File",
            },
          )}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <InputField
          name="a7_fia_instrument_from_id"
          label={i18n.t(
            "a7_fia_compositions.columns.a7_fia_instrument_from_name",
            {
              ns: "tables",
              defaultValue: "Fund",
            },
          )}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <InputField
          className="col-span-2"
          name="a7_fia_instrument_from_name"
          label={i18n.t(
            "a7_fia_compositions.columns.a7_fia_instrument_from_name",
            {
              ns: "tables",
              defaultValue: "Fund name",
            },
          )}
          fieldOptions={{ isDisabled: true }}
          variant="underlined"
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <InputField
          name="a7_fia_instrument_to_id"
          label={i18n.t("a7_fia_compositions.columns.a7_fia_instrument_to_id", {
            ns: "tables",
            defaultValue: "Financial instrument",
          })}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="a7_fia_issuer_name"
          label={i18n.t("a7_fia_compositions.columns.a7_fia_issuer_name", {
            ns: "tables",
            defaultValue: "Issuer",
          })}
          fieldOptions={{ isDisabled: true }}
          variant="underlined"
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 pt-2">
        <InputField
          name="valorisation_part_du_sous_jacent"
          label={i18n.t(
            "a7_fia_compositions.columns.valorisation_part_du_sous_jacent",
            {
              ns: "tables",
              defaultValue: "Valuation",
            },
          )}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="detention_du_fonds_dans_le_sous_jacent"
          label={i18n.t(
            "a7_fia_compositions.columns.detention_du_fonds_dans_le_sous_jacent",
            {
              ns: "tables",
              defaultValue: "Holding",
            },
          )}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <SelectField
          name="vehicle"
          label={i18n.t("a7_fia_compositions.columns.vehicle", {
            ns: "tables",
            defaultValue: "Vehicle",
          })}
          options={vehicle.map((c) => ({ value: c.value, label: c.value }))}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
    </div>
  ),
};
